import { css } from '@emotion/react'
import { Theme } from '@mui/material'

export const root = css`
  display: inline-block;
`

export const fieldWrap = css`
  display: flex;
  align-items: center;
  width: 320px;
  height: 40px;
  border: 1px solid #d7dbe0;
  border-radius: 8px;
  background: #ffffff;
  padding: 2px;
  transition:
    box-shadow 120ms ease,
    border-color 120ms ease;

  &:focus-within {
    border-color: #f6f6f6;
    box-shadow: 0 0 0 2px rgba(239, 239, 239, 0.35);
  }

  &[data-disabled] {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const inputCss = css`
  flex: 1 1 auto;
  height: 100%;
  min-width: 0;
  border: none;
  outline: none;
  padding: 0 12px;
  font-size: 14px;
  line-height: 1;
  color: #0b2948;
  background: transparent;

  &::placeholder {
    color: #9aa7b8;
  }
`

export const buttonCss = css`
  flex: 0 0 auto;
  height: 100%;
  padding: 0 12px;
  border: none;
  outline: none;
  border-radius: 0;
  background: #2897ff;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition:
    background 120ms ease,
    transform 50ms ease;

  &:hover {
    background: #1f88ea;
  }
  &:active {
    transform: translateY(0.5px);
  }
  &:disabled {
    cursor: not-allowed;
    background: #9ccbf9;
  }
`

export const container = css`
  display: grid;
  gap: 4px;
  line-height: 1.25;
  min-width: 0;
`

export const metaLine = (theme?: Theme) => css`
  font-size: 11.5px;
  font-style: italic;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${theme?.palette.primary.main};
`

export const title = css`
  font-weight: 600;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const description = css`
  font-size: 12.5px;
  opacity: 0.75;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
